import React from "react";
import "./ScrollingBanner.css";

const ScrollingBanner = () => {
  return (
    <div className="scroll-banner">
<div className="scroll-track">
  <p className="scroll-text">
    🌸 Join us in serving devotees with devotion, discipline, and dedication –
    <strong> Be a Garuda Sena Volunteer!</strong> 🌸
  </p>
  <p className="scroll-text">
    🙏 Join us in serving devotees with devotion, discipline, and dedication –
    <strong> Be a Garuda Sena Volunteer!</strong> 🙏
  </p>
  <p className="scroll-text">
    🔔 Join us in serving devotees with devotion, discipline, and dedication –
    <strong> Be a Garuda Sena Volunteer!</strong> 🔔
  </p>
</div>


    </div>
  );
};

export default ScrollingBanner;
